module.exports = __webpack_public_path__ + "assets/e0c085bc4dbf6a7c6f1e6a510685d7bf.svg";